module.exports = __webpack_public_path__ + "static/media/star-pattern-light.f4f1e0f2.svg";